import { fetchData, postData } from "../services/apis";

const path = "/sales";

export const salesVoucherApi = (value) => {
  let endPoint = `${path}/sales-vouchers`;
  return postData(endPoint, value);
};

export const getsalesReturnRecordApi = (value) => {
  let endPoint = `${path}/get-sales-return-record-with-details`;
  return postData(endPoint, value);
};

export const getCurrentStockApi = (value) => {
  let endPoint = `${path}/get-current-stock`;
  return postData(endPoint, value);
};

export const getSalesOrderRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-sales-order-record-with-details`;
  return postData(endPoint, value);
};

export const salesOrderDeleteApi = (value) => {
  let endPoint = `${path}/sales-order-delete`;
  return postData(endPoint, value);
};

export const salesQuotationWithRecordApi = (value) => {
  let endPoint = `${path}/get-sales-quotation-record-with-details`;
  return postData(endPoint, value);
};

export const salesDeleteApi = (value) => {
  let endPoint = `${path}/sale-delete`;
  return postData(endPoint, value);
};

export const salesDeleteCheckApi = (value) => {
  let endPoint = `${path}/sale-delete-check`;
  return postData(endPoint, value);
};

export const salesRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-sales-record-with-details`;
  return postData(endPoint, value);
};

export const savePadStatusApi = (value) => {
  let endPoint = `${path}/save-pad-status`;
  return postData(endPoint, value);
};

export const getSerialsOutApi = (value) => {
  let endPoint = `${path}/get-serials-outs`;
  return postData(endPoint, value);
};

export const getSalesReturnVoucherApi = () => {
  let endPoint = `${path}/get-sales-return-voucher-no`;
  return fetchData(endPoint);
};

export const getAvailableSerialsApi = (value) => {
  let endPoint = `${path}/get-available-serials`;
  return postData(endPoint, value);
};

export const getSalesOrderInvioceApi = (value) => {
  let endPoint = `${path}/get-sales-order-invoice`;
  return postData(endPoint,value);
};

export const getSerialsApi = (value) => {
  let endPoint = `${path}/get-serials`;
  return postData(endPoint, value);
};

export const getSalesVoucherApi = () => {
  let endPoint = `${path}/get-sales-voucher-no`;
  return postData(endPoint);
};

export const replaceDeleteApi = (value) => {
  let endPoint = `${path}/replace-delete`;
  return postData(endPoint, value);
};

export const replaceRecordWithDetailsApi = (value) => {
  let endPoint = `${path}/get-replace-record-with-details`;
  return postData(endPoint, value);
};

export const getReplaceVoucherNoApi = () => {
  let endPoint = `${path}/get-replace-voucher-no`;
  return fetchData(endPoint);
};

export const getUnavailableSerialsApi = (value) => {
  let endPoint = `${path}/get-unavailable-serials`;
  return postData(endPoint, value);
};

export const getCustomerCodeApi = (value) => {
  let endPoint = `${path}/get-customer-code`;
  return postData(endPoint, value);
};

export const salesReturnVouchersApi = (value) => {
  let endPoint = `${path}/sales-return-vouchers`;
  return postData(endPoint, value);
};

export const salesReturnDeleteCheckApi = (value) => {
  let endPoint = `${path}/sale-return-delete-check`;
  return postData(endPoint, value);
};

export const salesReturnDeleteApi = (value) => {
  let endPoint = `${path}/sales-return-delete`;
  return postData(endPoint, value);
};

export const SaveLocationApi = (locationDetails) => {
  let endPoint = `${path}/save-location-manage`;
  return postData(endPoint, locationDetails);
};

export const SaveCustomerGroupApi = (value) => {
  let endPoint = `${path}/save-customer-group`;
  return postData(endPoint, value);
};

export const getCustomerGroupApi = (value) => {
  let endPoint = `${path}/get-customer-groups`;
  return postData(endPoint, value);
};

export const deleteCustomerGroupApi = (value) => {
  let endPoint = `${path}/delete-customer-groups`;
  return postData(endPoint, value);
};

export const getCustomerListGroupApi = (value) => {
  let endPoint = `${path}/group-customers`;
  return postData(endPoint, value);
};

export const updateCustomerListGroupApi = (value) => {
  let endPoint = `${path}/update-customer-group`;
  return postData(endPoint, value);
};
export const removeCustomerListGroupApi = (value) => {
  let endPoint = `${path}/remove-customer-group`;
  return postData(endPoint, value);
};

export const saveSpecialPriceApi = (value) => {
  let endPoint = `${path}/save-special-price`;
  return postData(endPoint, value);
};

export const getSpecialPriceApi = () => {
  let endPoint = `${path}/get-special-price`;
  return fetchData(endPoint);
};

export const deleteSpecialPriceApi = (value) => {
  let endPoint = `${path}/delete-special-price`;
  return postData(endPoint, value);
};

export const getCustomerSpecialPriceApi = (value) => {
  let endPoint = `${path}/get-customert-special-price`;
  return postData(endPoint, value);
};

export const getPendingSalesOrderVoucherApi = (value) => {
  let endPoint = `${path}/get-pendimg-sales-order-vouchers`;
  return postData(endPoint, value);
};

export const getCustomerGroupPriceApi = (value) => {
  let endPoint = `${path}/get-customert-group-price`;
  return postData(endPoint, value);
};

export const getSalesReplaceVouchersApi = (value) => {
  let endPoint = `${path}/sales-replace-vouchers`;
  return postData(endPoint, value);
};

export const getSalesReturnVouchersApi = (value) => {
  let endPoint = `${path}/sales-return-voucher-list`;
  return postData(endPoint, value);
};

export const getSalesReturnedItemsApi = (value) => {
  let endPoint = `${path}/sale-returned-items`;
  return postData(endPoint, value);
};

export const getAvailableTatmeenSerialCollection = (value) => {
  let endPoint = `${path}/get-batch-serials`;
  return postData(endPoint, value);
};
export const getBatchSerialsApi  = (value) => {
  let endPoint = `${path}/get-batch-serials`;
  return postData(endPoint, value);
};

export const getTransactionHierarchyApi = (value) => {
    return postData(
        `${path}/get-transaction-hierarchy`,
        value
    );
};


